export default __webpack_public_path__ + "static/media/right_icon.08969edd.svg";